import uiRouter from '@uirouter/angularjs';
import ngTranslate from 'angular-translate';
import { LoadingModalService } from 'components/modals/loadingModal';

import { GridServiceModule } from './grid.service';

export const GridModule = angular
    .module('app.components.grid', [
        uiRouter,
        'ngMaterial',
        ngTranslate,
        LoadingModalService,

        GridServiceModule
    ]).name;



// WEBPACK FOOTER //
// ./src/app/components/grid/grid.module.js